export enum LogLevel { All = 0, Trace, Debug, Info, Warning, Error, Fatal, Off }

export default class Logging {
  private static loggerName: string;
  private static levelConsole: LogLevel;

  // Initialize the Logger
  public static Initialize(name: string, levelConsole: LogLevel = LogLevel.Off): void {
    this.LoggerName = name;
    this.LogLevelConsole = levelConsole;

    this.LogLevelConsole = this.setLevelFromUrlParameter(this.LogLevelConsole, 'logconsole');

    // eslint-disable-next-line no-console
    console.log('Initialize Logging:', this.LoggerName, LogLevel[this.LogLevelConsole]);

    // Log all Window Errors
    window.onerror = (message: string | Event, url: string, lineNumber: number, columnNumber: number, error: Error): void => {
      const errorMessage = `${message} - ${url} @ ${lineNumber}:${columnNumber}`;

      Logging.Error(errorMessage);

      if (error && error.stack) {
        Logging.Error(error.stack.toString());
      }
    };
  }

  // Set the Log Level from a Url Parameter
  private static setLevelFromUrlParameter(logLevel: LogLevel, parameter: string): LogLevel {
    let logLevelCopy: LogLevel = logLevel;

    if (window && window.location && window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);

      // Level Parameter is specified as a parameter on the Url
      if (urlParams.has(parameter)) {
        const levelString = urlParams.get(parameter);
        const levelFromParameters: LogLevel = this.getLogLevelFromString(levelString);

        // If a Valid Log Level is found in the Url, use it instead
        if (levelFromParameters !== undefined) {
          logLevelCopy = levelFromParameters;
          // eslint-disable-next-line no-console
          console.log('Setting Log Level from Url:', parameter, LogLevel[logLevelCopy]);
        } else {
          // eslint-disable-next-line no-console
          console.log('Invalid Log Level in Url:', parameter, levelString);
        }
      }
    }

    return logLevelCopy;
  }

  // Trace Logging
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static Trace(...parameters: any[]): void {
    this.log(LogLevel.Trace, parameters);
  }

  // Debug Logging
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static Debug(...parameters: any[]): void {
    this.log(LogLevel.Debug, parameters);
  }

  // Info Logging
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static Info(...parameters: any[]): void {
    this.log(LogLevel.Info, parameters);
  }

  // Warning Logging
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static Warning(...parameters: any[]): void {
    this.log(LogLevel.Warning, parameters);
  }

  // Error Logging
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static Error(...parameters: any[]): void {
    this.log(LogLevel.Error, parameters);
  }

  // Fatal Logging
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static Fatal(...parameters: any[]): void {
    this.log(LogLevel.Fatal, parameters);
  }

  // Convert the Log Level from a String to Enumeration
  private static getLogLevelFromString(level: string): LogLevel {
    switch (level.toLowerCase()) {
      case 'all':
        return LogLevel.All;

      case 'trace':
        return LogLevel.Trace;

      case 'debug':
        return LogLevel.Debug;

      case 'info':
        return LogLevel.Info;

      case 'warning':
        return LogLevel.Warning;

      case 'error':
        return LogLevel.Error;

      case 'fatal':
        return LogLevel.Fatal;

      case 'off':
        return LogLevel.Off;

      default:
        return undefined;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static log(logLevel: LogLevel, parameters: any[]): void {
    // Log to File
    if ((this.LogLevelConsole !== undefined) && (logLevel >= this.LogLevelConsole)) {
      this.console(parameters);
    }
  }

  // Log to Console
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static console(parameters: any[]): void {
    // eslint-disable-next-line no-console
    console.log(...parameters);
  }

  // Get Log Level
  static get LogLevelConsole(): LogLevel {
    return this.levelConsole;
  }

  // Set Log Level
  static set LogLevelConsole(level: LogLevel) {
    this.levelConsole = level;
  }

  // Get Logger Name
  static get LoggerName(): string {
    return this.loggerName;
  }

  // Set Logger Name
  static set LoggerName(loggerName: string) {
    this.loggerName = loggerName;
  }
}
